import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/business/visitor-parking/card'

export const TimerContainer = styled(DefaultCard)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.space['24'],
}))

export const TimeLeft = styled.p(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '6rem',
  fontVariantNumeric: 'tabular-nums',
  fontWeight: 600,
  lineHeight: '6rem',
}))

export const TimeLeftDimmed = styled.span(({ theme }) => ({
  color: theme.colors.black100,
}))

export const TimeLeftDescription = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
  fontWeight: 500,
}))
